// OK 06/11/2024

import { Materials } from "../interfaces";
import { ObjectId } from "../types";
import {  ip } from "../utils/setup";

const MATERIAL_API = `${ip}/api/Materiels`;


// GET

export async function getMaterials(): Promise<Materials[]> {
    const response = await fetch(MATERIAL_API, {
        credentials: "include" 
    });
  if (response.ok) {
    const body: Materials[] = await response.json();
    return body;
  } else {
    return response.json();
  }
}

// GET ID

export async function getMaterial(_id: ObjectId): Promise<Materials> {
    const response = await fetch(`${MATERIAL_API}/${_id}`, {
        credentials: "include" 
    });
  if (response.ok) {
    return response.json();
  } else {
    throw new Error("Erreur du serveur lors de la réception du matériel");
  }
}

// POST

export async function createMaterial(
  newMaterial: Partial<Materials>
): Promise<Materials> {
  const response = await fetch(MATERIAL_API, {
      method: "POST",
      credentials: "include" ,
    headers: {
        "content-type": "application/json",
        
    },
    body: JSON.stringify(newMaterial),
  });
  if (response.ok) {
    return response.json();
  } else {
    throw new Error(" Erreur lors de la création du nouveau matériel");
  }
}

//PUT

export async function updateMaterial(updateMaterial: Materials) {
  const { globalError, ...restMaterial } = updateMaterial;
  const response = await fetch(`${MATERIAL_API}/${restMaterial.idMat}`, {
      method: "PUT",
      credentials: "include" ,
      headers: {
          "Content-Type": "application/json",
        
      },
    body: JSON.stringify(restMaterial),
  });
  if (response.ok) {
    return response.ok;
  } else {
    throw new Error("Erreur lors de l'édition du matériel");
  }
}

// DELETE

export async function deleteMaterial(_id: ObjectId): Promise<ObjectId> {
  const response = await fetch(`${MATERIAL_API}/${_id}`, {
      method: "DELETE",
      credentials: "include" 
  });
  if (response.ok) {
    return _id;
  } else {
    throw new Error("Erreur lors de la suppression du matériel ");
  }
}
